export default __webpack_public_path__ + "static/media/product-6.4123d433.webp";